import { WhereClause } from "../ars_ldm";
import { isWhereClauseWithCompoundExpression } from "./isWhereClauseWithCompoundExpression";
import { isWhereClauseWithCondition } from "./isWhereClauseWithCondition";

/**
 * Type guard to check if a value is a WhereClause.
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClause
 */
export const isWhereClause = (obj: unknown): obj is WhereClause => {
  return isWhereClauseWithCondition(obj) || isWhereClauseWithCompoundExpression(obj);
};
